






























































































import {Component, Vue} from 'vue-property-decorator';
import ChartCard from '../../components/material/ChartCard.vue';
import StatsCard from '@/components/material/StatsCard.vue';
import {Action, Getter} from 'vuex-class';
import Card from '@/components/material/Card.vue';

@Component({
  components: {
    Card,
    StatsCard,
    ChartCard,
  },
})
export default class Dashboard extends Vue {
  @Getter('newsletter/all') private newsletter!: any[];
  @Getter('members/assorted') private members!: any[];
  @Action('newsletter/read') private readNewsletter!: () => any;
  @Action('members/read') private readMember!: () => any;

  private loading: boolean = false;

  private pagination: any = {
    sortBy: 'join_date',
    descending: true,
  };

  private paginationReason: any = {
    sortBy: 'amount',
    descending: true,
  };

  private headers: any = [
    {text: 'Datum', value: 'createdAt'},
    {text: 'Email', value: 'email'},
    {text: 'Name', value: 'name'},
    {text: 'Vereinsmitglied', value: 'member'},
    {text: 'Aktiviert', value: 'activated'},
  ];

  private headersRegistrationReasons: any = [
    {text: 'Mitglied', value: 'title'},
    {text: 'Anzahl an Anmeldungen', value: 'amount'},
  ];

  private async created(): Promise<any> {
    this.loading = true;
    await this.readNewsletter();
    await this.readMember();
    this.loading = false;
  }

  get newRegistrations() {
    const twentyFourHoursAgo = (new Date().getTime() - (24 * 60 * 60 * 1000));
    const newRegistrations: any = [];

    this.newsletter.forEach((newsletter) => {
      const createdAt = new Date(newsletter.createdAt).getTime();
      if (createdAt > twentyFourHoursAgo) {
        newRegistrations.push(newsletter);
      }
    });

    return newRegistrations;
  }

  get newWeeklyRegistrations() {
    const twentyFourHoursAgo = (new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
    const newRegistrations: any = [];

    this.newsletter.forEach((newsletter) => {
      const createdAt = new Date(newsletter.createdAt).getTime();
      if (createdAt > twentyFourHoursAgo) {
        if (newsletter.attributes) {
          newsletter.member = newsletter.attributes.REFERREDBYREASONNAME;
        }
        newRegistrations.push(newsletter);
      }
    });

    return newRegistrations;
  }

  get confirmedRegistrations() {
    return this.newsletter.filter((dude) => dude.listIds.indexOf(8) > -1);
  }

  get blacklisted() {
    return this.newsletter.filter((dude) => dude.emailBlacklisted);
  }

  get newsletterChart() {
    let dates: any = [];
    const series: any = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      dates.push(`${today.getDate()}.${today.getMonth() + 1}.`);
      series.push(0);
      today.setDate(today.getDate() - 1);
    }

    dates = dates.reverse();

    this.newsletter.forEach((recipient) => {
      const created = new Date(recipient.createdAt);
      const index = dates.indexOf(`${created.getDate()}.${created.getMonth() + 1}.`);
      if (index !== -1) {
        series[index] += 1;
      }
    });

    return {
      data: {
        labels: dates,
        series: [
          series,
        ],
      },
      chartOptions: {
        axisY: {
          onlyInteger: true,
        },
        low: 0,
        high: Math.max(...series) + 2,
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    };
  }

  get registrationReasons() {
    const reasons: any = {};

    this.newsletter.filter((dude) => dude.listIds.indexOf(8) > -1).forEach((recipient) => {
      if (!recipient.attributes) {
        return;
      }

      let memberId;

      if (this.members[recipient.attributes.REFERREDBYREASON]) {
        memberId = recipient.attributes.REFERREDBYREASON;
      } else if (this.members[recipient.attributes.MEMBER_ID]) {
        memberId = recipient.attributes.MEMBER_ID;
      } else {
        return;
      }

      if (!reasons[memberId]) {
        reasons[memberId] = {title: this.members[memberId].title, amount: 0};
      }
      reasons[memberId].amount++;
    });

    return Object.values(reasons);
  }
}
